export const getInitialAndColor = (name) => {
  const initial = name ? name.charAt(0).toUpperCase() : "?";

  const colors = [
    "bg-blue-500",
    "bg-green-500",
    "bg-purple-500",
    "bg-yellow-500",
    "bg-red-500",
    "bg-indigo-500",
    "bg-pink-500",
    "bg-teal-500",
  ];

  const hash = name
    .split("")
    .reduce((hash, char) => char.charCodeAt(0) + ((hash << 5) - hash), 0);

  const bgColor = colors[Math.abs(hash) % colors.length];

  return { initial, bgColor };
};
